import AddCircleIcon from "@mui/icons-material/AddCircle";
import { Box, Button, TableCell, Typography } from "@mui/material";
import React from "react";

import RegionAPI from "../api/Region.api";
import BasicCreateModal from "../components/BasicCreateModal";
import Layout from "../components/Layout";
import ListModel from "../components/ListModel";
import { Region, TableColumn } from "../types";
import { extractDate } from "../utils";

const columns: TableColumn<Region>[] = [
  { field: "name", label: "Name" },
  { field: "createdAt", label: "Created At Date" },
];

function buildTableRow(region: Region): JSX.Element[] {
  return [
    <TableCell key={"name"}>{region.name}</TableCell>,
    <TableCell key={"createdAt"}>{extractDate(region.createdAt)}</TableCell>,
  ];
}

export default function RegionList() {
  const [openModel, setOpenModal] = React.useState<boolean>(false);
  return (
    <Layout>
      <Box
        sx={{
          display: "flex",
          flexGrow: 1,
          flexDirection: "column",
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h2">Regions</Typography>
          <Button onClick={() => setOpenModal(true)}>
            <AddCircleIcon />
          </Button>
        </Box>

        <ListModel
          defaultOrderBy={"name"}
          modelApiUseList={RegionAPI.useList}
          modelBaseUrl={"regions"}
          columns={columns}
          buildTableRow={buildTableRow}
        />
        <BasicCreateModal
          open={openModel}
          onClose={() => setOpenModal(false)}
          modelApiUseSave={RegionAPI.useSave}
          navigateUrl="/regions"
        />
      </Box>
    </Layout>
  );
}
